export default __webpack_public_path__ + "static/ak-cached/24h/media/desk-ordering-page-hero-netflix.7d4f0b15.jpg";